import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadWon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 50 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		points: "50 64.84375 34.6930924 74.1931509 38.8548064 56.7462929 25.2329032 45.0776824 43.1118916 43.6443321 50 27.0833333 56.8881084 43.6443321 74.7670968 45.0776824 61.1451936 56.7462929 65.3069076 74.1931509",
		transform: "translate(-25 -26)",
		fill: "#2e9942",
		fillRule: "nonzero"
	})
});
export default SvgLeadWon;
